import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { apiEndPoints } from "../../../helpers/constants";
import { notify, notifyAPIMessages } from "../../../helpers/commonFunctions";
import { BASE_URL } from "../../../config";
import axios from "axios";
import { authHeaders } from "../../../helpers/axios";

export const reqToGetPlanList = createAsyncThunk(
  "reqToGetPlanList",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.getPlans}`,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetmodulesList = createAsyncThunk(
  "reqToGetmodulesList",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.getModules}`,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetPlanFeatureList = createAsyncThunk(
  "reqToGetPlanFeatureList",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.getPlanFeature}`,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetPlanDetails = createAsyncThunk(
  "reqToGetPlanDetails",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.getPlanDetails}/${id}`,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToGetSettingDetails = createAsyncThunk(
  "reqToGetSettingDetails",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.getSettingDetails}`,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToEditPlan = createAsyncThunk(
  "reqToEditPlan",
  async ({ id, data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.editPlan}/${id}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToTooglePlanManagement = createAsyncThunk(
  "reqToTooglePlanManagement",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}${apiEndPoints.togglePlanManagement}/${data?.id}`,
        data,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const planSlice = createSlice({
  name: "plans",
  initialState: {
    loader: false,
    error: null,
    plans: [],
    planFeatures: [],
    planDetails: {},
    totalCount: 0,
    settingDetails: [],
    modules: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    // GET PLANS
    builder.addCase(reqToGetPlanList.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetPlanList.fulfilled, (state, action) => {
      state.loader = false;
      state.plans = action.payload?.data?.data || [];
      state.totalCount = action.payload.headers["x-total-count"];
    });
    builder.addCase(reqToGetPlanList.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET PLANS FEATURES
    builder.addCase(reqToGetPlanFeatureList.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetPlanFeatureList.fulfilled, (state, action) => {
      state.loader = false;
      state.planFeatures = action.payload?.data?.data || [];
      state.totalCount = action.payload.headers["x-total-count"];
    });
    builder.addCase(reqToGetPlanFeatureList.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET SETTING DETAILS
    builder.addCase(reqToGetSettingDetails.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetSettingDetails.fulfilled, (state, action) => {
      state.loader = false;
      state.settingDetails = action.payload?.data?.result || [];
    });
    builder.addCase(reqToGetSettingDetails.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET PLAN DETAILS
    builder.addCase(reqToGetPlanDetails.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetPlanDetails.fulfilled, (state, action) => {
      state.loader = false;
      state.planDetails = action.payload?.data?.data || [];
    });
    builder.addCase(reqToGetPlanDetails.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // EDIT PLAN
    builder.addCase(reqToEditPlan.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToEditPlan.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToEditPlan.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // EDIT TOGGLE MANAGEMENT
    builder.addCase(reqToTooglePlanManagement.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToTooglePlanManagement.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToTooglePlanManagement.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // // GET MODULES
    // builder.addCase(reqToGetmodulesList.pending, (state) => {
    //   state.loader = true;
    // });
    // builder.addCase(reqToGetmodulesList.fulfilled, (state, action) => {
    //   state.loader = false;
    //   state.modules = action.payload?.data?.data || [];
    // });
    // builder.addCase(reqToGetmodulesList.rejected, (state, action) => {
    //   state.loader = false;
    //   state.error = action.payload;
    //   notifyAPIMessages(action.payload?.message || "Something went wrong");
    // });
  },
});

export default planSlice.reducer;
